"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnscheduledWorkWorkflow = void 0;
const react_1 = __importStar(require("react"));
const View_1 = require("@amzn/atoz-web/View");
const Theme_1 = require("@amzn/atoz-web/Theme");
const Card_1 = require("@amzn/atoz-web/Card");
const json_2_csv_1 = require("json-2-csv");
const uuid_1 = require("uuid");
const Shared_1 = require("../../components/Shared");
const consts_1 = require("../../consts");
const UnscheduledWorkWorkflowConfig_1 = require("../../components/UnscheduledWorkWorkflow/UnscheduledWorkWorkflowConfig");
const context_1 = require("../../components/UnscheduledWorkWorkflow/context");
const hooks_1 = require("./hooks");
const ErrorPerson_web_1 = require("../../components/Shared/ErrorPerson/ErrorPerson.web");
const components_1 = require("../../components");
const Steps_1 = require("../../components/UnscheduledWorkWorkflow/Steps");
const utils_1 = require("../../utils");
const UnscheduledWorkWorkflow = ({ associateInfo }) => {
    const [currentStep, setCurrentStep] = (0, react_1.useState)(1);
    const [totalSteps, setTotalSteps] = (0, react_1.useState)(2);
    const [currentStepTitle, setCurrentStepTitle] = (0, react_1.useState)('');
    const [isActionable, setIsActionable] = (0, react_1.useState)(true);
    const [travelStartTime, setTravelStartTime] = (0, react_1.useState)();
    const [travelStartDate, setTravelStartDate] = (0, react_1.useState)();
    const [travelEndTime, setTravelEndTime] = (0, react_1.useState)();
    const [mealBreakStartTime, setMealBreakStartTime] = (0, react_1.useState)();
    const [mealBreakEndTime, setMealBreakEndTime] = (0, react_1.useState)();
    const [travelEndDate, setTravelEndDate] = (0, react_1.useState)();
    const [reasonForTravel, setReasonForTravel] = (0, react_1.useState)();
    const [isMealBreakApplicable, setIsMealBreakApplicable] = (0, react_1.useState)(false);
    const [mealBreakDuration, setMealBreakDuration] = (0, react_1.useState)();
    const [duration, setDuration] = (0, react_1.useState)();
    const [isCurrentStepValid, setIsCurrentStepValid] = (0, react_1.useState)(true);
    const [showErrorFallback, setShowErrorFallback] = (0, react_1.useState)(false);
    const [isShowSummary, setIsShowSummary] = (0, react_1.useState)(false);
    const { setIsSubmitting, isSubmitting, submitTravelTime, status, title: summaryTitle, supportingText, caseId } = (0, hooks_1.useSubmitWorkflow)({
        associateInfo,
        setIsShowSummary
    });
    const onBack = () => {
        utils_1.BIAnalytics.clickBackInReportTravelTimeWorkflow();
        setShowErrorFallback(false);
        setIsActionable(true);
    };
    const onClose = () => {
        utils_1.BIAnalytics.closeReportTravelTimeWorkflow();
        const path = `${consts_1.ATOZ_FEATURE_PATH.TIME_CARD}`;
        location.assign(path);
    };
    const onContinue = () => {
        utils_1.BIAnalytics.clickContinueInReportTravelTimeWorkflow();
    };
    (0, react_1.useEffect)(() => {
        if (isShowSummary) {
            utils_1.BIAnalytics.arriveReportTravelTimeSummaryStepInRTTW();
        }
    }, [isShowSummary]);
    const generateCSV = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield (0, json_2_csv_1.json2csv)([
            {
                startDate: travelStartDate.toJSDate().toISOString().slice(0, 10),
                endDate: travelStartDate.toJSDate().toISOString().slice(0, 10),
                startTime: (0, components_1.convertTimeTo24HourFormat)(travelStartTime),
                duration: (0, components_1.convertDuration)(duration),
                employeeId: associateInfo.employeeId,
                businessLine: undefined,
                paycode: 'Travel Time',
                mealBreakStartTime: (0, components_1.convertTimeTo24HourFormat)(mealBreakStartTime),
                mealBreakEndTime: (0, components_1.convertTimeTo24HourFormat)(mealBreakEndTime),
                justificationForRequest: reasonForTravel,
                action: 'Add'
            }
        ], components_1.TIME_WIZARD_CSV_GENERATION_OPTIONS);
    });
    const onSubmit = () => {
        utils_1.BIAnalytics.submitReportTravelTimeWorkflow();
        setIsSubmitting(true);
        generateCSV()
            .then((response) => {
            const payload = {
                Origin: 'ATOZTimeCard',
                Type: 'Time & Attendance (MyTime)-USA-FC',
                Reason_for_Contact__c: 'Data Changes-Recode',
                OwnerId: '00G1Q000004tQPWUA2',
                RecordTypeId: '0121Q000001DvbmQAC',
                Resolver_Group__c: 'CTK_Admin_Queue',
                Subject: 'Reporting travel time',
                Description: reasonForTravel,
                RecordTypeName: 'Centralized_Time_Keeping',
                ExternalCaseRef__c: (0, uuid_1.v4)(),
                Published_to_employee__c: true
            };
            const attachments = [
                {
                    name: `PAY10003_1_${associateInfo.employeeId}_1234567890_1_1-ATOZTimeCard.csv`,
                    s3FilePath: null,
                    concernedEntityId: associateInfo.employeeId,
                    publishToConcernedEntity: false,
                    entityType: null
                }
            ];
            submitTravelTime(payload, attachments, response, duration);
        })
            .catch((err) => {
            console.error('Error Message from json-2-csv : ', err.message);
        });
    };
    const onBackSummary = status !== Shared_1.ToastIconStatus.success
        ? () => {
            setIsShowSummary(false);
        }
        : undefined;
    const renderSummaryContent = status === Shared_1.ToastIconStatus.error
        ? () => react_1.default.createElement(ErrorPerson_web_1.ErrorPerson, null)
        : () => react_1.default.createElement(Steps_1.MyHRCaseRedirect, { caseId: caseId });
    const stepConfig = UnscheduledWorkWorkflowConfig_1.unscheduledWorkWorkflowConfig.default;
    return (react_1.default.createElement(context_1.UnscheduledWorkflowContextProvider, { unscheduledWorkWorkflowInitial: {
            associateInfo,
            isActionable,
            paycodeName: 'Travel Time',
            isMealBreakApplicable,
            travelStartTime,
            travelStartDate,
            travelEndTime,
            travelEndDate,
            duration,
            reasonForTravel,
            mealBreakStartTime,
            mealBreakEndTime,
            showErrorFallback,
            isSubmitting,
            mealBreakDuration,
            setMealBreakDuration,
            setIsActionable,
            setIsCurrentStepValid,
            setCurrentStepTitle,
            setTravelStartDate,
            setTravelEndDate,
            setTravelStartTime,
            setTravelEndTime,
            setShowErrorFallback,
            setMealBreakStartTime,
            setReasonForTravel,
            setDuration,
            setTotalSteps,
            setIsMealBreakApplicable,
            setMealBreakEndTime
        } },
        react_1.default.createElement(View_1.View, { width: '100%', margin: 'auto', maxWidth: '842px', dataTestId: components_1.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.UNSCHEDULED_WORK },
            react_1.default.createElement(StyledCard, null, !isShowSummary ? (react_1.default.createElement(Shared_1.WorkflowStepsContainer, { currentStepTitle: currentStepTitle, currentStep: currentStep, setCurrentStep: setCurrentStep, totalSteps: totalSteps, isActionable: isActionable, isCurrentStepValid: isCurrentStepValid, showErrorFallback: showErrorFallback, onSubmit: onSubmit, onClose: onClose, onBack: onBack, onContinue: onContinue, isDisabled: false, submitButtonAriaLabel: 'time_and_attendance_ReportTravelTimeWorkflow_Submit_A11y', closeButtonAriaLabel: 'time_and_attendance_ReportTravelTimeWorkflow_Close_A11y', progressTrackerAriaLabel: 'time_and_attendance_ReportTravelTimeWorkflow_StepProgress' }, stepConfig.steps[currentStep - 1].renderStepComp())) : (react_1.default.createElement(Shared_1.WorkflowSummary, { dataTestId: components_1.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.UNSCHEDULED_WORK_SUMMARY, status: status, title: summaryTitle, supportingText: supportingText, onClose: onClose, onBack: onBackSummary, renderSummaryContent: renderSummaryContent, closeButtonAriaLabel: 'time_and_attendance_ReportTravelTimeWorkflow_Close_A11y' }))))));
};
exports.UnscheduledWorkWorkflow = UnscheduledWorkWorkflow;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
   display:flex;
   flex-direction: column;
   border: none;
`);
